import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

function sliderDesignGallery(): void {
  const element = document.querySelector('#designGallerySlider');
  if (!element) return;

  const splide = new Splide(element as HTMLElement, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: 32,
    arrows: false,
    pagination: false,
    drag: true,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: false,
    },
    breakpoints: {
      767: {
        perPage: 1,
        gap: 16,
        padding: {
          right: "21.28%",
        },
      },
    }
  });

  splide.mount({ AutoScroll });
}

export { sliderDesignGallery };
